import { render, staticRenderFns } from "./consulting-doctors-list.html?vue&type=template&id=78789d94&scoped=true&external"
import script from "./consulting-doctors-list.js?vue&type=script&lang=js&external"
export * from "./consulting-doctors-list.js?vue&type=script&lang=js&external"
import style0 from "./consulting-doctors-list.scss?vue&type=style&index=0&id=78789d94&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78789d94",
  null
  
)

export default component.exports